(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mooka-air-pollutants"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-mooka-air-init';

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var carousel = root.querySelector('[data-mooka-carousel]');
      if (!carousel) return;

      var viewport = carousel.querySelector('[data-mooka-viewport]');
      var track = carousel.querySelector('[data-mooka-track]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-mooka-slide]'));
      if (!viewport || !track || !slides.length) return;

      var prevBtn = carousel.querySelector('[data-mooka-prev]');
      var nextBtn = carousel.querySelector('[data-mooka-next]');
      var dotsWrap = carousel.querySelector('[data-mooka-dots]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var total = slides.length;
      var index = 0;
      var touchStartX = 0;
      var touchDeltaX = 0;

      function stepPx() {
        return viewport.clientWidth;
      }

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        slides.forEach(function (slide, i) {
          var li = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mooka-air-pollutants__dot' + (i === index ? ' is-active' : '');
          btn.textContent = '';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
          btn.addEventListener('click', function () {
            goTo(i);
          });
          li.appendChild(btn);
          dotsWrap.appendChild(li);
        });
      }

      function updateSlidesA11y() {
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
      }

      function applyTransform(animate) {
        if (!animate || reducedMotion) track.style.transition = 'none';
        else track.style.transition = '';

        track.style.transform = 'translate3d(' + -index * stepPx() + 'px, 0, 0)';

        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= total - 1;

        if (dotsWrap) {
          var dots = dotsWrap.querySelectorAll('.mooka-air-pollutants__dot');
          dots.forEach(function (dot, d) {
            var on = d === index;
            dot.classList.toggle('is-active', on);
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }

        updateSlidesA11y();

        if (!animate || reducedMotion) {
          requestAnimationFrame(function () {
            track.style.transition = '';
          });
        }
      }

      function goTo(i, animate) {
        index = Math.max(0, Math.min(total - 1, i));
        applyTransform(animate !== false);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(index + 1);
        });
      }

      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches.length) return;
          touchStartX = e.touches[0].clientX;
          touchDeltaX = 0;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchmove',
        function (e) {
          if (!e.touches.length) return;
          touchDeltaX = e.touches[0].clientX - touchStartX;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchend',
        function () {
          if (Math.abs(touchDeltaX) < 48) return;
          if (touchDeltaX < 0) goTo(index + 1);
          else goTo(index - 1);
        },
        { passive: true }
      );

      var resizeTimer;
      window.addEventListener('resize', function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          applyTransform(false);
        }, 100);
      });

      renderDots();
      applyTransform(false);
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-mooka-air-pollutants]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mooka-impact-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function isDesignMode() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function parseTarget(raw) {
    var cleaned = String(raw).trim().replace(/,/g, '').replace(/[^\d.-]/g, '');
    var n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
  }

  function decimalPlacesInRaw(raw) {
    var s = String(raw).trim().replace(/,/g, '');
    var dot = s.indexOf('.');
    if (dot === -1) return 0;
    return Math.min(s.length - dot - 1, 4);
  }

  function resolveTarget(el) {
    var display = el.getAttribute('data-display') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var core = display;

    if (prefix && core.indexOf(prefix) === 0) {
      core = core.slice(prefix.length);
    }
    if (suffix && core.length >= suffix.length && core.slice(-suffix.length) === suffix) {
      core = core.slice(0, core.length - suffix.length);
    }

    var fromDisplay = parseTarget(core);
    if (fromDisplay > 0) return fromDisplay;

    return parseTarget(el.getAttribute('data-value') || '');
  }

  function formatAnimFrame(value, target, raw) {
    var decimalPlaces = decimalPlacesInRaw(raw);
    var capped = Math.min(value, target);

    if (decimalPlaces > 0) {
      return String(Math.min(Math.floor(capped), Math.floor(target)));
    }

    return String(Math.round(capped));
  }

  function applyFinalDisplay(el) {
    var exact = el.getAttribute('data-display');
    if (exact != null && exact !== '') {
      el.textContent = exact;
      return;
    }
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var raw = el.getAttribute('data-value') || '';
    el.textContent = prefix + raw.trim() + suffix;
  }

  function animateCount(el) {
    if (el.getAttribute('data-count-done') === 'true') return;

    var raw = el.getAttribute('data-value') || '';
    var target = resolveTarget(el);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = parseInt(el.getAttribute('data-duration') || '1800', 10);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      applyFinalDisplay(el);
      el.setAttribute('data-count-done', 'true');
      return;
    }

    var startTime = null;

    function frame(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);

      if (progress >= 1) {
        applyFinalDisplay(el);
        el.setAttribute('data-count-done', 'true');
        return;
      }

      var current = target * eased;
      el.textContent = prefix + formatAnimFrame(current, target, raw) + suffix;
      requestAnimationFrame(frame);
    }

    el.textContent = prefix + formatAnimFrame(0, target, raw) + suffix;
    requestAnimationFrame(frame);
  }

  function resetCounts(root) {
    root.querySelectorAll('[data-mooka-count]').forEach(function (el) {
      el.removeAttribute('data-count-done');
    });
  }

  function initRoot(root) {
    var nodes = root.querySelectorAll('[data-mooka-count]');
    if (!nodes.length) return;

    resetCounts(root);

    nodes.forEach(function (node) {
      applyFinalDisplay(node);
    });

    if (isDesignMode()) {
      nodes.forEach(animateCount);
      return;
    }

    nodes.forEach(function (node) {
      if (!('IntersectionObserver' in window)) {
        animateCount(node);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.removeAttribute('data-count-done');
            animateCount(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
      );

      observer.observe(node);
    });
  }

  function init() {
    document.querySelectorAll('[data-mooka-impact]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mooka-impact]');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:reorder', init);

  if (isDesignMode()) {
    document.addEventListener('shopify:block:select', function () {
      setTimeout(init, 60);
    });
    document.addEventListener('shopify:section:select', function () {
      setTimeout(init, 60);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mooka-lab-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-mooka-lab-init';

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var video = root.querySelector('[data-mooka-lab-video]');
      if (!video) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var srcLoaded = false;
      var inView = false;

      function lazyLoad() {
        if (srcLoaded) return Promise.resolve();
        var url = video.getAttribute('data-src');
        if (!url) return Promise.resolve();
        video.src = url;
        srcLoaded = true;
        return new Promise(function (resolve) {
          if (video.readyState >= 2) {
            resolve();
            return;
          }
          video.addEventListener(
            'loadeddata',
            function done() {
              video.removeEventListener('loadeddata', done);
              resolve();
            },
            { once: true }
          );
          video.load();
        });
      }

      function play() {
        if (reducedMotion) {
          lazyLoad().then(function () {
            video.setAttribute('controls', '');
          });
          return;
        }
        lazyLoad().then(function () {
          if (!inView) return;
          video.play().catch(function () {
            video.setAttribute('controls', '');
          });
        });
      }

      function pause() {
        video.pause();
        if (!reducedMotion) video.removeAttribute('controls');
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
              if (inView) play();
              else pause();
            });
          },
          { threshold: [0, 0.35] }
        );
        observer.observe(root);
      } else {
        lazyLoad().then(function () {
          video.setAttribute('controls', '');
        });
      }

      document.addEventListener('visibilitychange', function onVis() {
        if (document.hidden) pause();
      });

      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-mooka-lab-section]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
